import { render, staticRenderFns } from "./TermoLavagemAuto.vue?vue&type=template&id=e630e4f0&"
import script from "./TermoLavagemAuto.vue?vue&type=script&lang=js&"
export * from "./TermoLavagemAuto.vue?vue&type=script&lang=js&"
import style0 from "./TermoLavagemAuto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports